import { useEffect } from 'react';
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';
import '../Pages/Home.css'

import BANV1 from '../images/BANV1.mp4'
// import BANV1 from '../images/BANV2.webm'


import ABIMG from '../images/ABIMG.png'

import PR1 from '../images/PR1.webp'
import PR2 from '../images/PR2.webp'
import PR3 from '../images/PR3.webp'
import PR4 from '../images/PR4.png'

import PR8 from '../images/PR8.jpg'
import PR23 from '../images/PR23.webp'
import PR11 from '../images/PR11.avif'


import PR15 from '../images/PR15.webp'
import PR10 from '../images/PR10.avif'
import PR24 from '../images/PR24.webp'
import PR25 from '../images/PR25.avif'

import PR14 from '../images/PR14.jpg'     
import PR16 from '../images/PR16.jpg'     
     
      
import BRAND1 from '../images/BRAND1.png'     
import BRAND2 from '../images/BRAND2.jpg'    
import BRAND3 from '../images/BRAND3.jpg'    
import BRAND4 from '../images/BRAND4.png'    
import BRAND5 from '../images/BRAND5.jpg'    
import PR26 from '../images/PR26.jpg'    
import PR27 from '../images/PR27.webp'    
import PR28 from '../images/PR28.jpg'    
export default function Home() {

    useEffect(() => {
        const carouselElement = document.querySelector('#heroCarousel');
        if (carouselElement) {
          new window.bootstrap.Carousel(carouselElement, {
            interval: 3000,
            ride: 'carousel',
            pause: false, 
            wrap: true
          });
        }
      }, []);
      
      const mediaItems = [BANV1];
      const captions = [
        "Strong Foundation, Strong Future",
        // "Building with Trust",
        // "Innovation in Every Brick",
        // "Quality Construction Guaranteed",
        // "We Build Your Vision"
      ];


useEffect(() => {
       window.scrollTo(0, 0); 
     }, []);




  return (
    <>
    <Navbar/>
    

    <section id="hero-ban">
  <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">
    <div className="carousel-inner">
      {mediaItems.map((media, index) => {
        const isVideo = media.endsWith(".mp4");

        return (
          <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
            {isVideo ? (
              <video className="d-block w-100 banner-img" autoPlay loop muted>
                <source src={media} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={media} className="d-block w-100 banner-img" alt={`Slide ${index + 1}`} />
            )}
            <div className="carousel-caption full-center d-flex align-items-center justify-content-center">
              <h2>{captions[index]}</h2>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>

    <section id="about" className="py-5">
  <div className="container">
    <div className="row align-items-center">

      {/* Text Section */}
      <div className="col-lg-6 col-md-6 col-sm-12 mb-4 mb-md-0">
        <p className="about-text">
         In the year 2015, he increasing demand for CNC machines emerged as a neccessity for precise machining and maintaining quality and consistency of parts Recognizing this, <strong>OM ENTERPRISES</strong> became protective in introdicing high-end CNC carble tooling for industries such as automotive, aeromotive, aerospace, oil and gas, wind energy, electroninc and general engineeing.
          <br /><br />
          Today <strong>OM ENTERPRISES</strong> has the capability to cater to industries of all scales, including small, medium, and large enterprises. Their protfolio comprises a wide range of product and solutions in turning, milling, parting-grooving, threading, deburring and more....
        </p>
      </div>

      {/* Image Section */}
      <div className="col-lg-6 col-md-6 col-sm-12 text-center">
        <img src={ABIMG} alt="About Small Tools Centre" title="Precision Machining" className="img-fluid rounded shadow" />
      </div>

    </div>
  </div>
</section>





<section id="product" style={{ padding: '20px' }}>
  <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Hardware Products</h2>
  <div className="product-grid">
    
    <div className="product-card">
      <img src={PR1} alt="Graphics Card" />
      <h3>Insets</h3>
     
    </div>
    <div className="product-card">
      <img src={PR2} alt="Processor" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR3} alt="Motherboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR4} alt="RAM 16GB" />
      <h3>Insets</h3>
    
    </div>
    {/* <div className="product-card">
      <img src={PR5} alt="SSD 1TB" />
      <h3>Insets</h3>
      
    </div> */}

    {/* <div className="product-card">
      <img src={PR6} alt="Power Supply" />
      <h3>Insets</h3>
     
    </div> */}
    {/* <div className="product-card">
      <img src={PR7} alt="Cooling Fan" />
      <h3>Insets</h3>
      
    </div> */}
    <div className="product-card">
      <img src={PR8} alt="Cabinet" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR23} alt="Monitor" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR10} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR11} alt="Keyboard" />
      <h3>Insets</h3>
     
    </div>
    <div className="product-card">
      <img src={PR24} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR25} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR14} alt="Keyboard" />
      <h3>Insets</h3>
     
    </div>
    <div className="product-card">
      <img src={PR15} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR16} alt="Keyboard" />
      <h3>Insets</h3>
     
    </div>
    <div className="product-card">
      <img src={PR25} alt="Keyboard" />
      <h3>Insets</h3>
     
    </div>
  
    <div className="product-card">
      <img src={PR26} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR27} alt="Keyboard" />
      <h3>Insets</h3>
      
    </div>
    <div className="product-card">
      <img src={PR28} alt="Keyboard" />
      <h3>Insets</h3>
   
    </div>

  </div>
</section>

<section id="contact-form" style={{ padding: '40px 20px', background: 'linear-gradient(to right, #FFDE21,rgb(224, 196, 41))', minHeight: '100vh' }}>
  <h2 style={{ textAlign: 'center', color: '#fff', marginBottom: '30px', fontSize: '32px' }}>
    Contact Us
  </h2>
  
  <div className="form-container">
    <form className="form">
      <input type="text" placeholder="Your Name" required />
      <input type="email" placeholder="Your Email" required />
      <input type="text" placeholder="Subject" />
      <textarea placeholder="Your Message" rows="5" required></textarea>
      <button type="submit">Send Message</button>
    </form>
  </div>
</section>








<section id="our-brands" style={{ padding: '40px 20px', backgroundColor: '#f0f4f8' }}>
  <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '32px', color: '#333' }}>Our Brand Dealerships</h2>

  <div className="brand-grid">
    <div className="brand-card">
      <img src={BRAND1} alt="Brand 1" />
      <h4>Lubrikote</h4>
    </div>
    <div className="brand-card">
      <img src={BRAND2} alt="Brand 2" />
      <h4>Venlub</h4>
    </div>
    <div className="brand-card">
      <img src={BRAND3} alt="Brand 3" />
      <h4>JJ Tools</h4>
    </div>
    <div className="brand-card">
      <img src={BRAND4} alt="Brand 4" />
      <h4>Ferament Global</h4>
    </div>
    <div className="brand-card">
      <img src={BRAND5} alt="Brand 5" />
      <h4>Tooling Solutions</h4>
    </div>
    
  </div>
</section>



<section id="faq" style={{ padding: '40px 20px', backgroundColor: '#f9f9f9' }}>
  <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '32px' }}>Hardware Tools FAQ</h2>
  
  <div className="faq-container">
    <div className="faq-item">
      <h3>🔩 What are the best screws for wood?</h3>
      <p>Wood screws with coarse threads are best for wooden projects. They grip the wood tightly and provide strong support.</p>
    </div>

    <div className="faq-item">
      <h3>🔧 How do I choose the right bolt and nut size?</h3>
      <p>Select a bolt size that fits the thickness of your material and matches the thread pitch of the nut. Always check load requirements.</p>
    </div>

    <div className="faq-item">
      <h3>🛠️ How powerful should a drilling machine be for concrete?</h3>
      <p>For drilling concrete, use a hammer drill with at least 6 to 8 amps power and masonry drill bits for efficient performance.</p>
    </div>

    <div className="faq-item">
      <h3>✂️ What is the best cutting machine for metals?</h3>
      <p>Angle grinders and plasma cutters are excellent for cutting metals quickly and cleanly depending on the metal thickness.</p>
    </div>

    <div className="faq-item">
      <h3>🏗️ How to safely operate a wall breaker machine?</h3>
      <p>Always wear safety gear, ensure the surface is marked properly, and use two hands on the breaker for better control and stability.</p>
    </div>
  </div>
</section>


<section id="open-hours" style={{ padding: '40px 20px', backgroundColor: '#FFDE21' }}>
  <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '32px', color: '#006064' }}>Open Hours</h2>

  <div className="hours-container">
    <table className="hours-table">
      <thead>
        <tr>
          <th>Day</th>
          <th>Status</th>
          <th>Opening Time</th>
          <th>Closing Time</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Monday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Tuesday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Wednesday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Thursday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Friday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Saturday</td>
          <td>Open</td>
          <td>9:00 AM</td>
          <td>9:00 PM</td>
        </tr>
        <tr>
          <td>Sunday</td>
          <td style={{ color: 'red' }}>Closed</td>
          <td>-</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
<Footer/>
    </>
  )
}
